import(/* webpackMode: "eager", webpackExports: ["ParceirosContent"] */ "/app/app/parceiros/parceiros-content.tsx");
